const styles = (theme) => ({
  root: {
    cursor: "none !important",

    zIndex: "100",
    display: "flex",
    top: "50%",
    left: "64px",
    transform: "translateY(-50%)",
    position: "fixed",
    transition: "all 0.2s ease",
    justifyContent: "center",
    alignItems: "start",
    flexDirection: "column",
    minWidth: "100px",
  },
  hideLi: {
    cursor: "none !important",

    fontSize: "0px !important",
    "& $liActive": {
      fontSize: "0 !important",
    },
  },
  liActive: {
    cursor: "none !important",

    fontSize: "12px !important",
    color: "#000 !important",
    opacity: "1 !important",
    lineHeight: "14px",
    letterSpacing: "0.055em",
    "&::before": {
      backgroundColor: "#000 !important",
      transformOrigin: "center",
      transition: "all 0.2s ease",
      transform: "translateY(-90%) scale(1.8) !important",
    },
  },
  onHome: {
    fontSize: "10px",
  },
  ul: {
    cursor: "none !important",

    listStyleType: "none",
    fontSize: "10px",
    padding: 0,
    minWidth: "100px",
    lineHeight: "1.1rem",
    "&:hover": {
      fontSize: "10px !important",
      "& $liActive": {
        fontSize: "12px !important",
      },
    },
  },
  a: {
    cursor: "none !important",

    textDecoration: "none",
    color: "inherit",
    letterSpacing: "0.055em",
    fontFamily: "Montserrat",
    fontSize: "inherit",
    position: "relative",

    textTransform: "uppercase",
  },
  li: {
    cursor: "none !important",
    fontFamily: "Aktiv Grotesk",
    fontSize: "inherit",
    position: "relative",
    color: "#000",
    height: "30px",
    transition: "all 0.2s ease",

    [theme.breakpoints.down(theme.breakpoints.values.xs + 1000)]: {
      display: "none",
    },
    opacity: "0.5",
    transformOrigin: "left",
    fontWeight: "700",
    padding: "6px 0",
    "&::before": {
      content: "''",
      transition: "all 0.2s ease",
      position: "absolute",
      height: "6px",
      width: "6px",
      backgroundColor: "#000",
      top: "50%",
      left: "-15px",
      transform: "translateY(-50%)",
    },
    "&:hover": {
      opacity: "1",
      transform: "scale(1.3)",
      marginLeft: "3px",
      transformOrigin: "0px",
      color: "#000",
      "&::before": {
        backgroundColor: "#000",
        transform: "translateY(-50%) scale(1.5) rotate(45deg) ",
        transformOrigin: "center",
      },
    },
  },
});

export default styles;
